const CREDIT_CARD = 'credit_card';
const PIX = 'pix';

/**
 * A API entrega as taxas como fração: 0.085 é 8,5%, nunca 8.5.
 *
 * A conversão mora só aqui de propósito. Espalhar `* 100` pelas telas é
 * exatamente como se erra por 100x, e a validação do backend (`between:0,1`)
 * recusa qualquer valor em porcentagem que escape daqui.
 */
const serviceFee = {
    METHODS: { CREDIT_CARD, PIX },

    /** 0.085 -> 8.5 */
    toPercent: (rate) => {
        const value = Number(rate);
        return Number.isFinite(value) ? value * 100 : 0;
    },

    /** 8,5 -> 0.085 — aceita vírgula, que é o que o usuário digita */
    fromPercent: (percent) => {
        const value = Number(String(percent ?? '').replace(',', '.'));
        return Number.isFinite(value) ? value / 100 : 0;
    },

    /** 0.085 -> '8,5%'  |  0.1 -> '10%' */
    formatPercent: (rate, { decimals = 2 } = {}) => {
        const fixed = serviceFee.toPercent(rate).toFixed(decimals);
        const trimmed = fixed.replace(/\.?0+$/, '') || '0';

        return `${trimmed.replace('.', ',')}%`;
    },

    /**
     * Taxa por unidade no meio de pagamento escolhido.
     *
     * Aceita um lote ou um produto: no carrinho, ingresso entra como lote e
     * produto entra inteiro, então cai no lote ativo dele.
     *
     * `service_fees` é o campo novo, com os dois meios. `service_fee` continua
     * existindo e continua sendo o valor de cartão — é o fallback para quando a
     * resposta ainda vier de uma versão anterior da API.
     */
    perUnit: (item, method = CREDIT_CARD, absorbed = false) => {
        if (!item || absorbed) {
            return 0;
        }

        const batches = item.batches || [];
        const hasOwnFee = item.service_fees !== undefined || item.service_fee !== undefined;
        const source = hasOwnFee ? item : (batches.find((batch) => batch.is_active) || batches[0]);

        if (!source) {
            return 0;
        }

        const fees = source.service_fees;
        const value = fees && fees[method] !== undefined ? fees[method] : source.service_fee;

        return Number(value) || 0;
    },
};

export default serviceFee;
